import { Action } from '@ngrx/store';
import { OrderForm, Fi2XmlOrderForm } from '@model';
import { ProductCategoryInformation } from 'app/models/product-category-information.model';


export enum ProductsActionTypes {
  ProductsLoad = '[Products] Load data',
  ProductsLoadSuccess = '[Products] Load success',
  ProductsLoadFail = '[Products] Load fail',
  PurchaseFi2Xml = '[Fi2Xml] purchase',
  PurchaseFi2XmlSuccess = '[Fi2Xml] purchase success',
  PurchaseFi2XmlFail = '[Fi2Xml] purchase fail',
  IsFi2XmlRegisteredOnCustomer = '[Fi2Xml] is registered',
  IsFi2XmlRegisteredOnCustomerSuccess = '[Fi2Xml] is registered success',
  IsFi2XmlRegisteredOnCustomerFail = '[Fi2Xml] is registered fail'
}

export class ProductsLoad implements Action {
  readonly type = ProductsActionTypes.ProductsLoad;
  constructor() {}
}

export class ProductsLoadSuccess implements Action {
  readonly type = ProductsActionTypes.ProductsLoadSuccess;
  constructor(public payload: ProductCategoryInformation) {}
}

export class ProductsLoadFail implements Action {
  readonly type = ProductsActionTypes.ProductsLoadFail;
  constructor(public payload: any) {}
}


export class PurchaseFi2Xml implements Action {
  readonly type = ProductsActionTypes.PurchaseFi2Xml;
  constructor(public payload: Fi2XmlOrderForm) {}
}

export class PurchaseFi2XmlSuccess implements Action {
  readonly type = ProductsActionTypes.PurchaseFi2XmlSuccess;
  constructor(public payload: boolean) {}
}

export class PurchaseFi2XmlFail implements Action {
  readonly type = ProductsActionTypes.PurchaseFi2XmlFail;
  constructor(public payload: any) {}
}


export class IsFi2XmlRegisteredOnCustomer implements Action {
  readonly type = ProductsActionTypes.IsFi2XmlRegisteredOnCustomer;
  constructor(public payload: string) {}
}

export class IsFi2XmlRegisteredOnCustomerSuccess implements Action {
  readonly type = ProductsActionTypes.IsFi2XmlRegisteredOnCustomerSuccess;
  constructor(public payload: Fi2XmlOrderForm) {}
}

export class IsFi2XmlRegisteredOnCustomerFail implements Action {
  readonly type = ProductsActionTypes.IsFi2XmlRegisteredOnCustomerFail;
  constructor(public payload: any) {}
}

export type ProductsActions =
  | ProductsLoad
  | ProductsLoadSuccess
  | ProductsLoadFail
  | PurchaseFi2Xml
  | PurchaseFi2XmlSuccess
  | PurchaseFi2XmlFail
  | IsFi2XmlRegisteredOnCustomer
  | IsFi2XmlRegisteredOnCustomerSuccess
  | IsFi2XmlRegisteredOnCustomerFail;
